
import { mapState } from 'pinia';
import { useWebview } from '@Stores/webview';

const steps = ['1', '2', undefined];

export default {
  name: 'CustomerLayout',
  props: {
    /**
     * PreviousCta data
     */
    previousCtaData: {
      type: Object,
      default: undefined,
    },
    /**
     * User form step
     */
    step: {
      type: String,
      default: undefined,
      validator: (val) => steps.includes(val),
    },
    /**
     * Title data
     * @see patterns/customer-title
     */
    title: {
      type: Object,
      default: undefined,
    },
  },
  computed: {
    ...mapState(useWebview, ['inWebview']),

    previousCta() {
      return {
        icon: {
          name: 'arrow-back',
          size: 32,
        },
        ...this.previousCtaData,
      };
    },
    cssClass() {
      return {
        '-has-sticky-cta':
          this.inWebview && this.currentRoute === 'additional-information',
      };
    },
    currentRoute() {
      return this.getRouteBaseName();
    },
  },
  methods: {
    previous() {
      this.$emit('previousScreen');
    },
  },
};
